var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group" }, [
    _vm.label ? _c("label", [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(),
    _c(
      "div",
      { staticClass: "input-container" },
      [
        _c(
          "Sketch",
          _vm._b(
            {
              attrs: { value: _vm.form, disabled: _vm.disabled },
              on: { input: _vm.onSetValue },
            },
            "Sketch",
            _vm.$attrs,
            false
          )
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }